import { mainSelector, userSelector } from '$store/main';
import { useSelector } from 'react-redux';
import { AccountModel, UserModel } from '$store/models';

interface Account extends AccountModel {
  user: UserModel;
}

export const useAccounts = (): Account[] => {
  const { accounts, users } = useSelector(mainSelector);

  return accounts.map((account) => ({
    ...account,
    user: users[account.id],
  }));
};
